import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogWrapperComponent } from '../../wrappers/dialog-wrapper/dialog-wrapper.component';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { BaseDialogDirective } from '../../base/base-dialog.directive';
import { InputComponent } from '../../controllers/input/input.component';
import { ButtonComponent } from '../../button/button.component';
import { ButtonSize, ButtonStyle } from '../../../enums/button.enum';
import { DynamicValidationDependencies } from '../../controllers/control-error/validation-error-messages.token';

@Component({
  selector: 'app-apt-suite-dialog',
  templateUrl: './apt-suite-dialog.component.html',
  styleUrl: './apt-suite-dialog.component.scss',
  imports: [
    DialogWrapperComponent,
    ReactiveFormsModule,
    InputComponent,
    ButtonComponent,
    ...DynamicValidationDependencies
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AptSuiteDialogComponent extends BaseDialogDirective {
  protected readonly ButtonStyle = ButtonStyle;
  protected readonly ButtonSize = ButtonSize;

  aptSuite: FormControl = new FormControl<string>(this.dialogData['aptSuite'], [
    Validators.required
  ]);

  onSave() {
    if (this.aptSuite.invalid) {
      this.aptSuite.markAllAsTouched();
      return;
    }

    this.closeDialog(this.aptSuite.value);
  }
}
